/* 
* <license header>
*/

// UserPanel is a reusable component for displaying user info in the nav
export { UserPanel } from './UserPanel'

// Note: UserProfile page has been moved to src/pages/UserProfile.tsx
